import React from "react";
import { useNavigate, Link } from "react-router-dom";

/* =====================================================================
   Footer
   =====================================================================
   The home page had no footer component at all -- it ended with a row of
   nine provider logos and one 11px line of small print. This is an actual
   footer: navigation, help, and the responsible-gambling and age
   information a gambling product is expected to carry where people can
   see it.

   The provider marks are kept, but muted to grey and moved below the
   content, so they read as a row of credentials rather than the loudest
   thing on the page.
   ===================================================================== */

const PROVIDER_LOGOS = [
  "/assets/images/footer1.png",
  "/assets/images/footer2.png",
  "/assets/images/footer3.png",
  "/assets/images/footer4.png",
  "/assets/images/footer5.png",
  "/assets/images/footer6.png",
  "/assets/images/footer7.png",
  "/assets/images/footer8.png",
  "/assets/images/footer9.svg",
];

const COLUMNS = [
  {
    heading: "Sports",
    links: [
      { label: "Cricket", path: "/cricketreal" },
      { label: "Football", path: "/footballreal" },
      { label: "Tennis", path: "/tennisreal" },
      { label: "All Sports", path: "/sportall" },
    ],
  },
  {
    heading: "Casino",
    links: [
      { label: "Slots", path: "/casinoGames", state: { list: 16 } },
      { label: "Live Casino", path: "/casinoGames", state: { list: 7 } },
      { label: "Table Games", path: "/casinoGames", state: { list: 18 } },
      { label: "Crash Games", path: "/casinoGames", state: { list: 11 } },
    ],
  },
  {
    heading: "Help",
    links: [
      { label: "Rules & FAQ", path: "/rules" },
      { label: "Contact us", path: "/contact-us" },
      { label: "Responsible gambling", path: "/responsible-gaming" },
      { label: "Cookie policy", path: "/cookie-policy" },
    ],
  },
];

const RbFooter = () => {
  const navigate = useNavigate();

  const go = (e, link) => {
    e.preventDefault();
    navigate(link.path, link.state ? { state: link.state } : undefined);
  };

  return (
    <footer className="rb-footer">
      <div className="rb-footer__inner">
        <div className="rb-footer__cols">
          <div className="rb-footer__brand">
            <Link to="/" aria-label="Rajbet65 home">
              <img className="rb-footer__logo" src="/assets/images/rajbet65-logo.png" alt="Rajbet65" />
            </Link>
            <p className="rb-footer__blurb">
              Sports betting and casino games. Odds and markets are provided by
              our data partners and can change at any time.
            </p>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.heading}>
              <div className="rb-footer__heading">{col.heading}</div>
              <ul className="rb-footer__list">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a href={link.path} onClick={(e) => go(e, link)}>
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Age and responsible-gambling notice. Previously an 11px grey
            sentence under the logos; it is now a bordered block with a
            route behind it. */}
        <div className="rb-footer__rg">
          <span className="rb-footer__age" aria-hidden="true">
            18+
          </span>
          <p className="rb-footer__rg-text">
            <strong>Play responsibly.</strong> You must be 18 or over, or the
            legal age for gambling in the place you live, and you must live
            somewhere that permits online gambling for residents. Gambling
            involves risk and should never be treated as a way to make money.{" "}
            <a
              href="/responsible-gaming"
              onClick={(e) => go(e, { path: "/responsible-gaming" })}
              style={{ color: "var(--rb-gold)" }}
            >
              Set a limit or take a break
            </a>
            .
          </p>
        </div>

        <div className="rb-footer__logos" aria-label="Game providers">
          {PROVIDER_LOGOS.map((src) => (
            <img key={src} src={src} alt="" loading="lazy" />
          ))}
        </div>

        <div className="rb-footer__bottom">
          <span>&copy; {new Date().getFullYear()} Rajbet65</span>
          <span className="rb-footer__legal">
            <a href="/rules" onClick={(e) => go(e, { path: "/rules" })}>
              Terms
            </a>
            <a href="/cookie-policy" onClick={(e) => go(e, { path: "/cookie-policy" })}>
              Privacy
            </a>
            <a
              href="/responsible-gaming"
              onClick={(e) => go(e, { path: "/responsible-gaming" })}
            >
              Responsible gambling
            </a>
            <a href="/contact-us" onClick={(e) => go(e, { path: "/contact-us" })}>
              Support
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default RbFooter;
